<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    v-model="selected"
    :items="employmentTypes"
    :menu-props="{ offsetY: true, overflowY: true, closeOnContentClick: true }"
    color="blue-grey lighten-2"
  >
    <template v-if="$attrs.hasOwnProperty('multiple')" v-slot:selection="{ item, index }">
      <div v-if="index === 0">
        {{ index === 0 ? `${selected.length} ${$t("global.selected", [$t("leave.type.employment_type")])}` : "" }}
      </div>
    </template>
    <template v-else v-slot:selection="{ item, index }">
      {{ $t(`employment_type.${item.toLowerCase()}`) }}
    </template>

    <template slot="item" slot-scope="data">
      <template>
        <v-list-item-avatar size="30" color="primary">
          <span class="white--text font-weight-bold">{{
            $t(`employment_type.${data.item.toLowerCase()}`)
              .substring(0, 2)
              .toUpperCase()
          }}</span>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="$t(`employment_type.${data.item.toLowerCase()}`)"></v-list-item-title>
        </v-list-item-content>
      </template>
    </template>
  </v-select>
</template>

<script>
  import employmentTypes from "./employmentTypes";

  export default {
    name: "EmploymentTypesPicker",
    props: {
      value: [String, Object, Array]
    },
    data: () => ({
      employmentTypes,
      selected: []
    }),
    watch: {
      value: {
        handler(v) {
          this.selected = v;
        },
        immediate: true
      }
    }
  };
</script>

<style scoped></style>
